// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriptionSignatureModel {
    static getAttributeTypeMap() {
        return PrescriptionSignatureModel.attributeTypeMap;
    }
}
PrescriptionSignatureModel.discriminator = undefined;
PrescriptionSignatureModel.attributeTypeMap = [
    {
        "name": "signatureId",
        "baseName": "signatureId",
        "type": "number"
    },
    {
        "name": "isSigned",
        "baseName": "isSigned",
        "type": "boolean"
    },
    {
        "name": "signatureDate",
        "baseName": "signatureDate",
        "type": "Date"
    },
    {
        "name": "dispenseAsWritten",
        "baseName": "dispenseAsWritten",
        "type": "boolean"
    },
    {
        "name": "isSubstitutionAllowed",
        "baseName": "isSubstitutionAllowed",
        "type": "boolean"
    }
];
//# sourceMappingURL=prescriptionSignatureModel.js.map